import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { PrependUrl } from 'enums';
import { fetchWithCsrfToken } from 'utils/fetchWrapper';

export enum PeriodType {
  DAY = 'Day',
  WEEK = 'Week',
  MONTH = 'Month',
}

export interface AssessmentSettings {
  uid: string;
  start_date: string;
  closed_date: string;
  is_public: boolean;
  is_practice: boolean;
  interview_time_zone: string;
  has_rolling_applicant_deadline: boolean;
  rolling_applicant_deadline: number;
  rolling_applicant_deadline_period?: PeriodType;
  number_of_invited_applicants: number;
}

const useGetAssessmentSettings = (interviewUid: string) => {
  const { data, isLoading } = useQuery<AssessmentSettings, Error>(
    ['getAssessmentSettings', interviewUid],
    async () =>
      fetchWithCsrfToken<AssessmentSettings>(
        `${PrependUrl.ASYNC}/assessment/get_settings`,
        'POST',
        { interview: interviewUid }
      ),
    {
      enabled: !!interviewUid,
    }
  );

  const formatedData = useMemo(() => {
    if (!data?.rolling_applicant_deadline) {
      return data;
    }

    if (data.rolling_applicant_deadline % 30 === 0) {
      return {
        ...data,
        rolling_applicant_deadline_period: PeriodType.MONTH,
        rolling_applicant_deadline: data.rolling_applicant_deadline / 30,
      };
    }

    if (data.rolling_applicant_deadline % 7 === 0) {
      return {
        ...data,
        rolling_applicant_deadline_period: PeriodType.WEEK,
        rolling_applicant_deadline: data.rolling_applicant_deadline / 7,
      };
    }

    return { ...data, rolling_applicant_deadline_period: PeriodType.DAY };
  }, [data]);

  return {
    data: formatedData,
    isLoading,
  };
};

export default useGetAssessmentSettings;
